<template>
  <div>
    <!-- 绑定golo账号 -->
    <div class="form-item border-bottom">
      <div class="name">
        账号
      </div>
      <div>
        <input type="text" placeholder="请输入golo账号" v-model="accout">
      </div>
    </div>
    <div class="form-item border-bottom">
      <div class="name">
        密码
      </div>
      <div>
        <input type="password" placeholder="请输入golo账号密码" v-model="password">
      </div>
    </div>
    <a href="javascript:;" class="tx-btn" @click="bindgolo">立即绑定</a>
  </div>
</template>

<script>
import {bindGoloUser} from '@/api/user-center.js'
import {RES_OK} from '@/api/config'
export default {
  data() {
    return {
      accout: '',
      password: ''
    }
  },
  methods: {
    bindgolo() {
      if (this.accout.length === 0) {
        this.$toast('请输入账号')
        return
      }
      if (this.password.length === 0) {
        this.$toast('请输入密码')
        return
      }
      bindGoloUser(this.accout, this.password).then((res) => {
        let data = res.data
        console.log(data)
        if (data && data.code === RES_OK) {
          this.$toast('绑定成功')
          setTimeout(() => {
            this.$router.push({path: '/personal'})
          }, 2000)
        } else {
          this.$toast(data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .form-item
    display table
    width 100%
    min-height size(100)
    padding 0 size(24)
    .name
      width size(98)
    >div
      display table-cell
      vertical-align middle
      input
        outline none
        border none
        width 100%
        font-size: size(28)
        padding size(12) 0
  .tx-btn
    display block
    text-align center
    background $color-theme
    border-radius 4px
    color #ffffff
    font-weight 700
    font-size size(32)
    line-height size(80)
    margin size(30) size(28)
</style>



// WEBPACK FOOTER //
// src/components/personal/bind/bind.vue